import React, { useEffect, useRef } from "react";
import { canv } from "@/canv/global";
import type { ShapeWidget } from "../types";
import style from "./shapeResult.module.css";

export function ShapeResult({ widgetData }: { widgetData: ShapeWidget }) {
    const svgStr = canv.shapeStorage
        .getShape(widgetData?.shapeType)
        .getView("voteResult", widgetData.color, widgetData.borderColor);
    const svgRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (svgRef.current) {
            const parser = new DOMParser();
            const svgDoc = parser.parseFromString(svgStr, "image/svg+xml");
            const svgElement = svgDoc.documentElement;

            svgRef.current.innerHTML = "";
            svgRef.current.appendChild(svgElement);
        }
    }, [svgStr]);

    return <div className={style.svgWrapper} ref={svgRef} />;
}
